export default "__VITE_ASSET__BwEvZLm6__"